import { render, staticRenderFns } from "./ResponsiblePage.vue?vue&type=template&id=8bd1b9cc"
import script from "./ResponsiblePage.vue?vue&type=script&lang=ts"
export * from "./ResponsiblePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports